import { useModelContext } from '@app/contexts/model';
import { Stack } from '@mui/system';
import { observer } from 'mobx-react';
import React, { FC } from 'react';
import { MainLanguage } from './MainLanguage';
import { TargetLanguage } from './TargetLanguage';

type TProps = {
    // onChange(value: string)
    // className: string
};

export const LanguageChoice: FC<TProps> = observer((props: TProps) => {
    const { languageModel } = useModelContext();

    return (
        <Stack direction={'row'} justifyContent={'space-between'}>
            <MainLanguage />
            <TargetLanguage />
        </Stack>
    );
});
